import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { handleHttp, isWx, locationHandlev2, tengxunCardlocation } from "@/utils/utils";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import VueAudio from "vue-audio";
// import 'vue-audio-player/dist/vueaudioplayer.css'

import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: "简介",
        id: 0
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: "",
      infoList: [],
      videoitem: "",
      videoitemflag: false,
      daohangflag: true,
      viewer: null,
      audiodescflag: false,
      audiodesc: null,
      timer: null,
      structList: [],
      structLabel: {},
      structImgdefaultValues: {}
    };
  },
  components: {
    VueAudio
  },
  watch: {
    // "$attrs.detail"(val) {
    //   if (val && Object.keys(val).length > 0) {
    //     console.log(`detail`, val)
    //     if (this.structList.length === 0) {
    //       this.pointStruct();
    //     } else {
    //       this.setLeftTitle();
    //     }
    //   }
    // },
    // "$attrs.detail.banner"(val) {
    //   if (val) {
    //     this.$nextTick(() => {
    //       console.log(`111this.$refs.swipercontainer`, this.$refs.swipercontainer);
    //       this.swiperEl = new Swiper(this.$refs.swipercontainer, {
    //         initialSlide: 0,
    //         slidesPerView: this.$attrs.isMobile ? 1 : 2.3,
    //         autoplay: true,
    //         speed: 500,
    //         spaceBetween: this.$attrs.isMobile ? 0 : 10,
    //         observeSlideChildren: true,
    //         observeParents: true,
    //         observer: true,
    //       });
    //     });
    //     // 延迟初始化viewer，确保DOM完全加载
    //     setTimeout(() => {
    //       this.initViewer();
    //     }, 500);
    //   }
    // },
  },
  created() {
    isWx().then(type => {
      this.daohangflag = type === "mini-wx" ? false : true;
      // 自贡/浙江嘉兴/杭锦旗单位 放开
      const daohangFid = ['4666', '2883', '185879'];
      if (daohangFid.includes(this.$route.query.fid)) this.daohangflag = true;

      // 晋江
      if (this.$route.query.fid === '2226') {
        const type2 = ['晋江非遗', '历史名人'];
        if (this.$attrs.detail.map_type2 === undefined || this.$attrs.detail.map_type2 === 'null') return;
        let isInclude = false;
        type2.forEach(item => {
          if (this.$attrs.detail.map_type2.includes(item)) isInclude = true;
        });
        if (isInclude) this.daohangflag = false;
      }
    });
  },
  mounted() {
    if (this.$attrs.detail && Object.keys(this.$attrs.detail).length > 0) {
      if (this.structList.length === 0) {
        this.pointStruct();
      } else {
        this.setLeftTitle();
      }
    }
    if (this.$attrs.detail.banner.length > 0) {
      this.$nextTick(() => {
        this.swiperEl = new Swiper(this.$refs.swipercontainer, {
          initialSlide: 0,
          slidesPerView: this.$attrs.isMobile ? 1 : 2.3,
          autoplay: false,
          speed: 500,
          spaceBetween: this.$attrs.isMobile ? 0 : 10,
          observeSlideChildren: true,
          observeParents: true,
          observer: true,
          navigation: this.$attrs.isMobile ? {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          } : false
        });
        // 延迟初始化viewer，确保DOM完全加载
        setTimeout(() => {
          this.initViewer();
        }, 500);
      });

      // 洱源先关闭语音自动播放
      if (this.$route.query.fid === '291435') this.audiodescflag = true;
    }
  },
  methods: {
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.$emit("closeHandle");
      this.popshowflag = false;
      this.popLeftIndex = 0;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
        this.audiodescflag = false;
      }
      this.closevideoItem();
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = "";
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = "";
    },
    goLocation(url) {
      if (this.$route.query.fid === '332213' && window.self !== window.top) {
        // 在iframe内，通知父页面打开链接
        window.parent.postMessage({
          type: 'portal-open-webview',
          url
        }, '*');
      } else {
        locationHandlev2.call(this, this.$attrs.detail, url);
      }
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === "是") {
        window.open(url);
      } else {
        // 当前页面打开第三方链接时 关掉语音讲解
        if (!this.audiodescflag) {
          this.$refs.audiodesc.pause();
          this.audiodescflag = !this.audiodescflag;
        }
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.videoitem = this.popLeftIndex === 2 ? item : item.itemformdata;
    },
    initViewer() {
      this.$nextTick(() => {
        if (this.viewer) {
          this.viewer.destroy();
          this.viewer = null;
          return;
        }
        let that = this;
        this.viewer = new Viewer(document.querySelector(".swiper-wrapper"), {
          navbar: true,
          // 显示导航栏
          toolbar: true,
          // 显示工具栏
          title: false,
          viewed() {
            console.log(`this.$attrs.imgrotate`, that.$attrs.imgrotate);
            if (that.$attrs.imgrotate !== undefined && that.$attrs.imgrotate) that.viewer.rotateTo(90);
            document.querySelector(".viewer-container").classList.add(`fid${that.$route.query.fid}`);
          }
        });
      });
    },
    getAddress(val) {
      let data = val[0];
      let addressArr = ["country", "province", "city", "district", "street"];
      let str = "";
      addressArr.forEach(elem => {
        if (data[elem] && data[elem] !== undefined && data[elem] !== "") str += data[elem];
      });
      if (str === "" && data.address !== undefined) str = data.address;
      return str;
    },
    playaudiodesc() {
      this.audiodescflag = !this.audiodescflag;
      if (this.audiodescflag) {
        this.$refs.audiodesc.pause();
      } else {
        this.$refs.audiodesc.play().catch(error => {
          console.error("Play request was interrupted:", error);
        });
      }
    },
    /**
     * 获取地点管理表表单结构
     */
    pointStruct() {
      let params = {
        deptId: this.$route.query.fid,
        formId: 165054
      };
      this.$api.formStruct(params).then(res => {
        this.structList = JSON.parse(JSON.stringify(res));
        this.structList.forEach(elem => {
          if (elem.compt === "imagebox" && elem.field.values.length > 0) this.structImgdefaultValues[elem.alias] = elem.field.values[0].fileUrl;
          this.structLabel[elem.alias] = elem.label;
        });
        this.setLeftTitle();
        console.log(`this.structLabel`, this.structLabel);
        console.log(`this.structImgdefaultValues`, this.structImgdefaultValues);
      });
    },
    setLeftTitle() {
      let audioList = this.$attrs.detail.audio;
      if (audioList && audioList.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: this.structLabel.audio,
          id: 3
        });
      }
      let videoList = this.$attrs.detail.video;
      if (videoList && videoList.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: this.structLabel.video,
          id: 2
        });
      }
    },
    formatIntroduce(content) {
      return content.replace(/noteyd.chaoxing.com/g, location.protocol + '//noteyd.chaoxing.com');
    }
  }
};